import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
import AgGrid from '@components/AgGrid/AgGrid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import screenfull from 'screenfull';
import styled from 'styled-components';
import SimpleLinkRenderer from '@pages/_components/simpleLinkRenderer';
import * as R from 'ramda';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { withConfirm } from '../confirmationDialog';
import {
  Divider,
  HeaderContainer,
  Title,
  SearchTextField,
  FullScreenButton,
  TableContainer,
} from '../../pages/propertyPage/components/tableStyledComponents';
import './subjectProperties.scss';
import { preferenceSelector } from '@modules/appraisal/selectors/global';
import * as globalActions from '@modules/appraisal/actions/global';
import { setLastOrderColumnsR, setVisibleColumnsR, setWidthR } from '@utils';

class SubjectProperties extends Component {
  static propTypes = {
    confirm: PropTypes.func.isRequired,
    history: PropTypes.object,
    properties: ImmutablePropTypes.map,
    subjectId: PropTypes.number.isRequired,
    subjectType: PropTypes.string.isRequired,
    updateNote: PropTypes.func.isRequired,
    fetchPreference: PropTypes.func.isRequired,
    persistPreference: PropTypes.func.isRequired,
    preference: PropTypes.any,
  };

  state = {
    newComment: '',
    screenMaximized: false,
    fullSize: false,
  };

  getColumnDefs() {
    const { preference } = this.props;
    const columnDefs = [
      {
        headerName: 'Prop ID',
        field: 'pid',
        width: 130,
        maxWidth: 130,
        minWidth: 130,
        cellRenderer: SimpleLinkRenderer,
        cellRendererParams: {
          onClick: (_, record) => {
            window.open(
              `/appraisal/property/${record.pid}/${record.pYear}/${record.pVersion}/${record.pRollCorr}`,
              '_blank',
            );
          },
        },
      },
      { headerName: 'Situs Address', field: 'situs' },
      { headerName: 'Legal', field: 'legalDescription' },
      { headerName: 'Market Value', field: 'marketValue' },
      { headerName: 'Active', field: 'active' },
    ];
    const visibleColumns = preference.getIn([
      'data',
      'owmerSubjectProperties',
      'visibleColumns',
    ]);
    const movedColumns = preference.getIn([
      'data',
      'owmerSubjectProperties',
      'movedColumns',
    ]);
    const columnsWidth = preference.getIn([
      'data',
      'owmerSubjectProperties',
      'columnsWidth',
    ]);

    return R.compose(
      setWidthR(columnsWidth),
      setLastOrderColumnsR(movedColumns),
      setVisibleColumnsR(visibleColumns),
    )(columnDefs);
  }

  maximizeWidget() {
    const el = document.getElementById('propertiesDisplay');
    screenfull.toggle(el);
    this.setState(prevState => ({
      fullSize: !prevState.fullSize,
    }));
    setTimeout(() => this.gridApi.sizeColumnsToFit(), 300);
  }

  searchChange(e) {
    const searchText = e.target.value;
    this.gridApi.setQuickFilter(searchText);
  }

  updateNote(event) {
    const { data, oldValue, newValue } = event;
    if (oldValue !== newValue) {
      this.props.updateNote({
        noteId: data.id,
        data: {
          content: newValue,
          lastUpdate: data.updateDt,
        },
      });
    }
  }

  render() {
    const {
      properties,
      fetchPreference,
      persistPreference,
      preference,
    } = this.props;
    const propertiesJs =
      properties && properties.get('data') && properties.get('data').toJS();
    const rowData =
      propertiesJs &&
      propertiesJs.map(row => ({
        pid: row.pid,
        situs: `${row.streetNum} ${row.streetName}`,
        marketValue: `${row.marketValue ? '$' + row.marketValue.toLocaleString('en') : ''
          }`,
        legalDescription: row.legalDescription,
        pYear: row.pYear,
        pVersion: row.pVersion,
        pRollCorr: row.pRollCorr,
        active: row.active,
      }));
    const { screenMaximized, fullSize } = this.state;
    return (
      <Container id="propertiesDisplay" screenMaximized={screenMaximized}>
        <Divider />
        <HeaderContainer>
          <Title>SUBJECT PROPERTIES</Title>
          <SearchTextField
            label="Search Properties"
            style={{ marginRight: 9, height: 35 }}
            variant="outlined"
            onChange={this.searchChange.bind(this)}
          />
          <FullScreenButton onClick={this.maximizeWidget.bind(this)}>
            {screenMaximized ? <Fullscreen /> : <FullscreenExit />}
          </FullScreenButton>
        </HeaderContainer>
        <TableContainer
          style={{
            height: fullSize ? 'calc(100vh - 200px)' : 300,
          }}
          className="ag-theme-material"
        >
          <AgGrid
            columnDefs={this.getColumnDefs()}
            // gridOptions={{
            //   editType: 'fullRow',
            //   onCellValueChanged: this.updateNote.bind(this),
            // }}
            name="owmerSubjectProperties"
            defaultColDef={{ resizable: true, sortable: true }}
            
            rowData={rowData ? rowData : []}
            onGridReady={params => {
              this.gridApi = params.api;
              this.gridApi.sizeColumnsToFit();
            }}
            persistPreference={persistPreference}
            preference={preference}
            fetchPreference={fetchPreference}
          />
        </TableContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  background-color: #fff;
`;

const mapDispatchToProps = {
  fetchPreference: globalActions.fetchPreference,
  persistPreference: globalActions.persistPreference,
};

const mapStateToProps = createStructuredSelector({
  preference: preferenceSelector,
});


export default R.compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirm,
)(SubjectProperties);
